module.exports = __webpack_public_path__ + "static/img/fish29.7caf1be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish29.png
// module id = gfM8
// module chunks = 0